{
  "level": "nrxmov",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:nrxmov",
    "objects": "AREAS.E3:nrxmov.e3",
    "mesh": "TREES.E3:nrxmov.e3"
  },
  "spawn_point": {
    "position": [
      0.0,
      0.0,
      0.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      0.0,
      100.0,
      0.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      0.0,
      0.0,
      0.0
    ],
    "bbox_max": [
      0.0,
      0.0,
      0.0
    ],
    "vertex_count": 0,
    "vertices": []
  },
  "sectors": [
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        -500.0,
        -100.0,
        -1300.0
      ],
      "bbox_max": [
        -200.0,
        0.0,
        -1300.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: melev1",
      "entity_class": "CSlidingDoor",
      "piece_name": "melev1",
      "offset": 441,
      "centroid": [
        539.2426452636719,
        804.7199951171875,
        64.39999847412109
      ],
      "bbox_min": [
        532.1715698242188,
        799.7999877929688,
        64.0999984741211
      ],
      "bbox_max": [
        546.313720703125,
        808.0,
        64.5999984741211
      ],
      "dimensions_source": {
        "span_x": 14.14215087890625,
        "span_y": 8.20001220703125,
        "height_z": 0.5,
        "door_width": 14.14215087890625,
        "door_depth": 8.20001220703125,
        "leaf_depth": 8.16001220703125,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          1.0,
          0.0
        ]
      },
      "vertices": [
        [
          532.1715698242188,
          799.7999877929688,
          64.5999984741211
        ],
        [
          532.1715698242188,
          808.0,
          64.5999984741211
        ],
        [
          532.1715698242188,
          808.0,
          64.5999984741211
        ],
        [
          546.313720703125,
          808.0,
          64.5999984741211
        ],
        [
          546.313720703125,
          808.0,
          64.5999984741211
        ],
        [
          546.313720703125,
          799.7999877929688,
          64.5999984741211
        ],
        [
          532.1715698242188,
          808.0,
          64.0999984741211
        ],
        [
          532.1715698242188,
          799.7999877929688,
          64.0999984741211
        ],
        [
          546.313720703125,
          799.7999877929688,
          64.0999984741211
        ],
        [
          546.313720703125,
          808.0,
          64.0999984741211
        ]
      ],
      "plane_distance": -808.0,
      "authentic_texture": "metrobottom2"
    }
  ],
  "tutorial_messages": []
}